import React, { Component } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import {
  fetchAccountPositions,
  fetchQuotesPrivate,
} from '../../actions';

import NonTradedDetail from './NonTradedDetail';

class NonTradedDetailContainer extends Component {
  componentDidMount() {
    const {
      accountNumber,
      securityId,
    } = this.props;
    if (accountNumber !== '') this.props.fetchAccountPositions(accountNumber);
    if (securityId) this.props.fetchQuotesPrivate(securityId);
  }
  render() {
    const {
      positions,
      securityId,
      priceData,
    } = this.props;
    const position = positions.filter(pos => (pos.security.ticker === securityId))[0];
    const purchasePrice = priceData && priceData.myipopurchaseprice;
    const currentPrice = priceData && priceData.last;
    const security = {
      name: `${get(position, 'security.companyName', '')}`,
      ticker: `${get(position, 'security.ticker', '')}`,
      quantity: get(position, 'shareQuantity') ? Number.parseFloat(get(position, 'shareQuantity')) : null,
      purchasePrice,
      totalCost: purchasePrice && purchasePrice * get(position, 'shareQuantity', 0),
      currentPrice,
      totalValue: currentPrice && currentPrice * get(position, 'shareQuantity', 0),
    };
    return (
      <NonTradedDetail securityId={securityId} security={security} />
    );
  }
}

const mapStateToProps = (state, { match: { params: { securityId } } }) => ({
  authToken: state.authToken,
  user: state.authTokenUser,
  positions: get(state.accountPositionsByAccount[state.currentAccount], 'data'),
  accountNumber: state.currentAccount,
  priceData: get(state, `quoteData['${securityId}'].pricedata`),
  securityId,
});

const mapDispatchToProps = {
  fetchAccountPositions,
  fetchQuotesPrivate,
};

export default connect(mapStateToProps, mapDispatchToProps)(NonTradedDetailContainer);



// WEBPACK FOOTER //
// ./src/components/NonTradedDetail/index.js